import { IBasket } from '@/types/simo/basket';

type IState = {
  subscriptionsGlobal: any;
  loadingGlobal?: boolean;
  basket: { basket: IBasket; responseCode: string };
  checkoutOverviewStep: {
    valgfriChecked: boolean;
    existingSubChecked: boolean;
    termsChecked: boolean;
  };
    apiError: boolean;
  fatalError: boolean;
};

type IActions = {
  payload: IState;
  type:
    | 'getBasket'
    | 'getSubscriptions'
    | 'updateUserInfoWithApiValues'
    | 'setFatalError'
    | 'setApiError'
    | 'checkoutOverviewStep'
    | 'setGlobalProperty';
};
export let store: IState = {
  subscriptionsGlobal: {},
  loadingGlobal: true,
  basket: { responseCode: '', basket: {} as IBasket },
  checkoutOverviewStep: { valgfriChecked: false, existingSubChecked: false, termsChecked: false },
  apiError: false,
  fatalError: false
};

const reducer = (state: any, action: IActions): IState | void => {
  switch (action.type) {
    case 'getBasket':
      store = { ...state, ...action.payload };
      return store;
    case 'updateUserInfoWithApiValues':
      store = { ...state, ...action.payload };
      return store;
    case 'setGlobalProperty':
      store = { ...state, ...action.payload };
      return store;
    case 'getSubscriptions': {
      const updatedStore = { ...store, ...action.payload };
      return updatedStore;
    }
    case 'checkoutOverviewStep':
      store = { ...store, ...action.payload };
      return store;
    case 'setFatalError':
      store = { ...store, ...action.payload };
      return store;
       case 'setApiError': 
      store = {...store, ...action.payload};
      return store
    default:
      console.error('No switch case found');
  }
};

export default reducer;
